export interface SiteVisitExitGuardState {
    busyCount?: number;
    failedCount?: number;
    sideRequestBusy?: boolean;
}

interface SiteVisitExitRequest {
    fromPage?: string;
    toPage?: string;
}

/**
 * A failed capture can retain its only retry File in the mounted visit.
 * Leaving is safe only after every capture and side-request mutation settles.
 */
export function shouldBlockSiteVisitExit(
    request: SiteVisitExitRequest | null | undefined,
    state: SiteVisitExitGuardState | null | undefined,
): boolean {
    if (request?.fromPage !== 'site-visits' || request?.toPage === 'site-visits') return false;
    return (Number(state?.busyCount) || 0) > 0
        || (Number(state?.failedCount) || 0) > 0
        || state?.sideRequestBusy === true;
}
